<template>
  <div class="order text-neutral-500">
    <div class="bg-white mb-40">
      <div class="flex gap-3 justify-between p-6 shadow-border-b">
        <div class="flex gap-3">
          <span class="flex justify-center items-center px-2 py-1 text-xs rounded-md" :style="'backgroundColor: ' + orderDetail.status_color + '; color: white;'">{{
            orderDetail.status_display
          }}</span>
          <div>
            <span class="text-neutral-500 text-xs block mb-1">{{ orderDetail.created_time_display }} / {{ orderDetail.order_id }}</span>
            <p class="text-neutral-500 text-xs flex items-center gap-2 mdmax:flex-col mdmax:gap-1 mdmax:items-start">
              <span><strong>AWB Linknau</strong>: {{ orderDetail.order_delivery?.awb }}</span>
              <template v-if="orderDetail.order_delivery?.external_awb">
                <span class="mdmax:hidden">|</span> <span><strong>AWB Mitra</strong>: {{ orderDetail.order_delivery?.external_awb }}</span>
              </template>
            </p>
          </div>
        </div>
        <div class="" v-if="orderDetail.next_status">
          <Button buttonText="Update Status" @action="updateStatus()" />
        </div>
      </div>
      <div class="flex mdmax:flex-col">
        <div class="flex-1">
          <div class="p-6 shadow-border-b">
            <p class="text-xl font-bold mb-6 text-neutral-700">Berat dan Jenis Paket</p>
            <div
              class="flex justify-start gap-6 mb-4 border rounded-md px-3 py-2 bg-neutral-200 last:mb-0"
              v-for="(packageItem, index) in orderDetail?.order_delivery?.packages"
              :key="'package-' + index"
            >
              <div class="w-2/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Berat Barang</p>
                <p>{{ packageItem.weight }}kg</p>
              </div>
              <div class="w-3/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Jenis Paket</p>
                <p>{{ packageItem.category }}</p>
              </div>
            </div>
          </div>
          <div class="p-6 shadow-border-b">
            <p class="text-xl font-bold mb-6 text-neutral-700">Layanan</p>
            <div class="flex items-center">
              <div class="w-2/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Nama Layanan</p>
                <p>{{ orderDetail.order_delivery?.service_package_name || '-' }}</p>
              </div>
              <div class="w-3/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Tipe Layanan</p>
                <p>{{ getServiceType(orderDetail.order_delivery?.service_type) || '-' }}</p>
              </div>
            </div>
          </div>
          <div class="p-6">
            <p class="text-xl font-bold mb-6 text-neutral-700">Info Pengiriman</p>
            <div class="flex justify-start gap-6 mb-6">
              <div class="w-2/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Nama Pengirim</p>
                <p>{{ orderDetail?.order_delivery?.sender?.name || '-' }}</p>
              </div>
              <div class="w-3/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">No. HP Pengirim</p>
                <p>{{ orderDetail?.order_delivery?.sender?.phone_number || '-' }}</p>
              </div>
            </div>
            <p class="text-sm font-medium mb-1 text-neutral-700">Alamat Pengirim</p>
            <p>{{ orderDetail?.order_delivery?.sender?.address || '-' }}</p>
            <div class="mt-6 p-2 bg-neutral-200 rounded-md">
              <p class="text-sm font-medium mb-1 text-neutral-700">Detail Pickup</p>
              <p>{{ orderDetail?.order_delivery?.sender?.detail_address || '-' }}</p>
            </div>
          </div>
          <div class="p-6 mdmax:shadow-border-b">
            <p class="text-xl font-bold mb-6 text-neutral-700">Info Penerima</p>
            <div class="flex justify-start gap-6 mb-6">
              <div class="w-2/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Nama Penerima</p>
                <p>{{ orderDetail?.order_delivery?.receiver?.name || '-' }}</p>
              </div>
              <div class="w-3/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">No. HP Penerima</p>
                <p>{{ orderDetail?.order_delivery?.receiver?.phone_number || '-' }}</p>
              </div>
            </div>
            <p class="text-sm font-medium mb-1 text-neutral-700">Alamat Penerima</p>
            <p>{{ orderDetail?.order_delivery?.receiver?.address || '-' }}</p>
            <div class="mt-6 p-2 bg-neutral-200 rounded-md">
              <p class="text-sm font-medium mb-1 text-neutral-700">Detail Pickup</p>
              <p>{{ orderDetail?.order_delivery?.receiver?.detail_address || '-' }}</p>
            </div>
          </div>
        </div>
        <div class="flex-1 shadow-border-l mdmax:shadow-none">
          <div class="p-6 shadow-border-b">
            <p class="text-xl font-bold mb-6 text-neutral-700">Foto Barang</p>
            <div class="mb-4" v-for="(paket, index) in orderDetail?.order_delivery?.packages" :key="'paket-' + index">
              <template v-if="paket.photo_from_courier">
                <img :src="paket.photo_from_courier" />
              </template>
              <p v-else>- Foto tidak tersedia -</p>
            </div>
          </div>
          <div class="p-6 shadow-border-b">
            <p class="text-xl font-bold mb-6 text-neutral-700">Informasi Pembayaran</p>
            <div class="mb-6">
              <p class="text-sm font-medium mb-1 text-neutral-700">Status</p>
              <p>{{ orderDetail?.payment_info?.status || '-' }}</p>
            </div>
            <div class="flex justify-start gap-6 mb-6">
              <div class="w-2/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Tipe Pembayaran</p>
                <p>{{ orderDetail?.payment_info?.payment_method || '-' }}</p>
              </div>
              <div class="w-3/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">Bank</p>
                <p>{{ orderDetail?.payment_info?.payment_provider || '-' }}</p>
              </div>
            </div>
            <div class="flex justify-start gap-6 mb-6">
              <div class="w-2/5">
                <p class="text-sm font-medium mb-1 text-neutral-700">No Rekening</p>
                <p>{{ orderDetail?.payment_info?.payment_account_display || '-' }}</p>
              </div>
            </div>
          </div>
          <div class="p-6">
            <p class="text-xl font-bold mb-6 text-neutral-700">Status Pengiriman</p>
            <div class="flex gap-5" v-for="(tracking, index) in orderDetail?.tracking_infos" :key="'tracking' + index">
              <div class="line relative">
                <span class="inline-block w-5 h-5 rounded-full border-4 relative z-1" :class="index === 0 ? 'bg-primary-500 border-primary-100' : 'bg-neutral-500 border-neutral-300'"></span>
                <span class="absolute border-dashed border-neutral-300 h-full w-px border left-1/2 transform -translate-x-1/2 top-0 z-0"></span>
              </div>
              <div class="status mb-6">
                <p class="text-sm mb-1">{{ tracking.time_display }}</p>
                <p class="text-neutral-700 mb-1">{{ tracking.main_info }}</p>
                <p class="text-sm">{{ tracking.additional_info }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-xs p-4 flex items-center gap-2 bg-secondary-100 text-neutral-700" v-if="orderDetail.is_require_hubcek">
        <Info width="24" height="24" color="neutral-700" />Jangan lupa periksa kembali barang yang telah diterima sebelum memindahkan status order, pastikan sesuai dengan ukuran yang telah ditetapkan.
      </div>
      <div class="p-6 flex justify-end gap-4 items-center" v-if="orderDetail.is_require_hubcek">
        <template v-if="alreadyResponsed">
          <LinkButton buttonText="Kembali" url="/order" linkType="internal" />
        </template>
        <template v-else>
          <div class="w-44">
            <CustomSelect :options="rejectReasons" v-model="selectedReason" :default="selectedReason" placeholder="Pilih Aksi" />
          </div>
          <div class="w-44">
            <Button buttonText="Submit" size="big_full" @action="toggleConfirmModal('proceed')" :disabled="!selectedReason" />
          </div>
        </template>
      </div>
    </div>
    <Modal :modalVisible="visibleConfirmModal" @close="toggleConfirmModal()" width="600px" id="confirmation-modal">
      <template slot="modal-content">
        <div class="flex items-center justify-start gap-6 mb-6">
          <span class="flex-shrink-0"><Alert color="neutral-700" /></span>
          <div class="flex-col flex gap-2 items-start">
            <p class="text-2xl font-bold">Perubahan Status</p>
            <p class="text-sm text-neutral-500 text-left">Pastikan informasi alamat dan isi paket sesuai dengan ketentuan barang yang telah ditetapkan. perubahan proses tidak bisa di ubah</p>
          </div>
        </div>
        <div class="flex justify-end gap-4">
          <Button buttonText="Tidak" type="secondary" @action="toggleConfirmModal()" :size="isMobile ? 'full' : 'regular'" />
          <Button buttonText="Ya" type="primary" @action="proceed()" :size="isMobile ? 'full' : 'regular'" />
        </div>
      </template>
    </Modal>
    <Modal :modalVisible="visibleAddCostModal" @close="toggleAddCostModal()" width="660px" id="add-cost-modal">
      <template slot="modal-content">
        <p class="text-2xl font-bold mb-6 text-neutral-700 text-left">Kurang Bayar</p>
        <div class="flex items-center gap-6 text-left mb-6">
          <div class="flex-1">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Panjang</label>
            <div class="relative">
              <TextField borderEnabled type="number" v-model="packageLength" />
              <span class="absolute text-neutral-700 right-3 top-1/2 transform -translate-y-1/2">cm</span>
            </div>
          </div>
          <div class="flex-1">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Lebar</label>
            <div class="relative">
              <TextField borderEnabled type="number" v-model="packageWidth" />
              <span class="absolute text-neutral-700 right-3 top-1/2 transform -translate-y-1/2">cm</span>
            </div>
          </div>
          <div class="flex-1">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Tinggi</label>
            <div class="relative">
              <TextField borderEnabled type="number" v-model="packageHeight" />
              <span class="absolute text-neutral-700 right-3 top-1/2 transform -translate-y-1/2">cm</span>
            </div>
          </div>
        </div>
        <div class="text-left w-1/3 mb-10">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Penambahan Harga</label>
          <div class="relative">
            <TextField borderEnabled type="number" v-model="packagePrice" withIcon />
            <span class="absolute text-neutral-700 left-3 top-1/2 transform -translate-y-1/2">Rp</span>
          </div>
        </div>
        <div class="flex justify-end gap-4">
          <Button buttonText="Tutup" type="secondary" @action="toggleAddCostModal()" :size="isMobile ? 'full' : 'regular'" />
          <Button buttonText="Submit" type="primary" :disabled="invalidPackageInformation" @action="rejectAddCost()" :size="isMobile ? 'full' : 'regular'" />
        </div>
      </template>
    </Modal>
    <Modal :modalVisible="visibleOtherModal" @close="toggleOtherModal()" width="600px" id="confirmation-modal">
      <template slot="modal-content">
        <div class="p-1">
          <p class="text-2xl font-bold mb-6 text-neutral-700 text-left">Lainnya</p>
          <div class="mb-6">
            <Textarea v-model="otherReason" placeholder="Silakan tulis alasannya" borderEnabled :error="otherReasonError" />
          </div>
          <div class="flex justify-end gap-4">
            <Button buttonText="Tutup" type="secondary" @action="toggleOtherModal()" :size="isMobile ? 'full' : 'regular'" />
            <Button buttonText="Submit" type="primary" @action="rejectOther()" :size="isMobile ? 'full' : 'regular'" />
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    Info: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Info'),
    Button: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Button'),
    TextField: () => import(/* webpackChunkName: "form" */ '@/components/Forms/TextField'),
    Textarea: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Textarea'),
    LinkButton: () => import(/* webpackChunkName: "form" */ '@/components/Forms/LinkButton'),
    CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    Alert: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Alert'),
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/Modal/Modal')
  },
  data() {
    return {
      otherReason: null,
      packageLength: 0,
      packageWidth: 0,
      packageHeight: 0,
      packagePrice: 0,
      selectedApprovalStatus: null,
      visibleConfirmModal: false,
      status: {
        PYMWAI: 'text-neutral-500 bg-neutral-300',
        PYMCNF: 'text-white bg-system-warning',
        DLVD: 'text-white bg-system-success',
        CNC: 'text-white bg-system-error',
        HUBPRCD: 'text-white bg-system-warning',
        HUBRJCT: 'text-white bg-system-error'
      },
      deliveryServiceTypeList: [
        {
          name: 'Pickup and Dropoff',
          value: 'A'
        },
        {
          name: 'Pickup Only',
          value: 'P'
        },
        {
          name: 'Dropoff Only',
          value: 'D'
        }
      ],
      rejectReasons: ['Terima', 'Barang Terlarang', 'Kurang Bayar', 'Lainnya'],
      selectedReason: null,
      visibleAddCostModal: false,
      visibleOtherModal: false,
      otherReasonError: null
    }
  },
  computed: {
    ...mapGetters('order', ['orderDetail']),
    ...mapGetters('common', ['isMobile']),
    orderId() {
      return this.$route.params.id
    },
    statusClass() {
      return this.status[this.orderDetail.status]
    },
    alreadyResponsed() {
      return ['HUBRJCT', 'HUBPRCD'].indexOf(this.orderDetail.status) > -1
    },
    invalidPackageInformation() {
      return (
        !this.packageLength ||
        this.packageLength === 0 ||
        !this.packageWidth ||
        this.packageWidth === 0 ||
        !this.packageHeight ||
        this.packageHeight === 0 ||
        !this.packagePrice ||
        this.packagePrice === 0
      )
    }
  },
  created() {
    this.getOrderInfo()
  },
  // watch: {
  //   selectedReason(val) {
  //     if (val) this.toggleConfirmModal('reject')
  //   }
  // },
  methods: {
    ...mapActions('order', ['getOrderDetail', 'processOrder', 'rejectOrder', 'updateShipmentStatus']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    updateStatus() {
      this.showLoading()
      let self = this
      this.updateShipmentStatus({
        orderId: this.orderId,
        payloads: {
          shipment_status: self.orderDetail.next_status
        }
      })
        .then(() => {
          this.getOrderInfo()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    toggleAddCostModal() {
      this.visibleAddCostModal = !this.visibleAddCostModal
      if (!this.visibleAddCostModal) {
        this.selectedReason = null
      }
    },
    toggleOtherModal() {
      this.visibleOtherModal = !this.visibleOtherModal
      if (!this.visibleOtherModal) {
        this.selectedReason = null
      }
    },
    toggleConfirmModal() {
      // if (status) {
      //   this.selectedApprovalStatus = status
      // }
      this.visibleConfirmModal = !this.visibleConfirmModal
      if (!this.visibleConfirmModal) {
        this.selectedReason = null
      }
    },
    rejectOther() {
      this.otherReasonError = null
      if (this.otherReason) {
        this.visibleAddCostModal = false
        this.showLoading()
        this.rejectOrder({
          orderId: this.orderId,
          payloads: {
            reject_type: 'OTHERS',
            reason: this.otherReason
          }
        }).then(() => {
          this.hideLoading()
          this.setToast({
            options: { type: 'success', duration: 1000, primaryText: 'Order Status telah berubah', secondaryText: 'Data telah terimpan dalam sistem.', callback: this.handleCallback }
          })
        })
      } else {
        this.otherReasonError = 'Tuliskan terlebih dahulu alasannya!'
      }
    },
    rejectAddCost() {
      this.visibleAddCostModal = false
      this.showLoading()
      this.rejectOrder({
        orderId: this.orderId,
        payloads: {
          reject_type: 'ADDCOST',
          reason: 'Kurang Bayar',
          modified_package_size: {
            dimension: `${this.packageLength}x${this.packageWidth}x${this.packageHeight}`,
            addition_cost: parseInt(this.packagePrice)
          }
        }
      }).then(() => {
        this.hideLoading()
        this.setToast({
          options: { type: 'success', duration: 1000, primaryText: 'Order Status telah berubah', secondaryText: 'Data telah terimpan dalam sistem.', callback: this.handleCallback }
        })
      })
    },
    proceed() {
      this.visibleConfirmModal = false
      if (this.selectedReason === 'Terima') {
        this.showLoading()
        this.processOrder({
          orderId: this.orderId
        }).then(() => {
          this.hideLoading()
          this.setToast({
            options: { type: 'success', duration: 1000, primaryText: 'Order Status telah berubah', secondaryText: 'Data telah terimpan dalam sistem.', callback: this.handleCallback }
          })
        })
      } else if (this.selectedReason === 'Barang Terlarang') {
        this.showLoading()
        this.rejectOrder({
          orderId: this.orderId,
          payloads: {
            reject_type: 'DANGGOOD',
            reason: 'Barang Terlarang'
          }
        }).then(() => {
          this.hideLoading()
          this.setToast({
            options: { type: 'success', duration: 1000, primaryText: 'Order Status telah berubah', secondaryText: 'Data telah terimpan dalam sistem.', callback: this.handleCallback }
          })
        })
      } else if (this.selectedReason === 'Kurang Bayar') {
        this.visibleAddCostModal = true
      } else if (this.selectedReason === 'Lainnya') {
        this.visibleOtherModal = true
      }
    },
    handleCallback() {
      this.$router.push('/order')
    },
    reverseObject(array) {
      let newArr = Object.assign([], array)
      return newArr && newArr.reverse()
    },
    getServiceType(value) {
      return this.deliveryServiceTypeList.filter((item) => item.value === value)[0]?.name
    },
    getOrderInfo() {
      this.showLoading()
      this.getOrderDetail({
        orderId: this.orderId
      }).then(() => {
        this.hideLoading()
      })
    }
  }
}
</script>
<style></style>
